/* global $:true */
import debug from "debug";
import plugin from '../../lib/plugin';
import { type } from 'jquery';

const ELEMENT_SELECTOR = '[data-toggle-if-value-element]';
const ATTR_ELEMENT_SELECTOR = 'data-toggle-if-value-element';
const ELEMENT_VALUE_SELECTOR = 'data-toggle-if-value-value';
const ELEMENT_NOT_VALUE_SELECTOR = 'data-toggle-if-value-not-values';
const REMOVE_CLASS_NAME_SELECTOR = 'data-toggle-if-value-remove-classname';
const ON_HIDE_ELEMENTS_DEFAULT = 'clear';
const PLUGIN_NAME = 'toggleIfValue';
const MODULE_NAME = 'app.core/modules/toggle-if-value';
const log = debug(MODULE_NAME);

log('registerd');

class ToggleIfValue {

  constructor(element, options) {
      log('new instance', element, options);

      this.element = element;
      this.options = options;
      this.$element = $(element);
      this.toggleElement = this.$element.attr(ATTR_ELEMENT_SELECTOR);
      this.$toggleElement = $(this.toggleElement);
      this.togglevalue = this.$element.attr(ELEMENT_VALUE_SELECTOR);
      this.toggleNotValue = this.$element.attr(ELEMENT_NOT_VALUE_SELECTOR);
      this.removeClassname = this.$element.attr(REMOVE_CLASS_NAME_SELECTOR);
      this.removeClassname = typeof(this.removeClassname) != 'undefined' ? this.removeClassname : '';
      this.onHideAction = this.element.dataset["toggleIfValueOnHideAction"] || ON_HIDE_ELEMENTS_DEFAULT;

      this.onShow = this.onHideAction === 'clear'
        ? function(){}
        : this.enableElements.bind(this);

    this.onHide = this.onHideAction === 'clear'
        ? this.clearElement.bind(this)
        : this.disableElements.bind(this);

      this.$toggleElement.on('keyup', this.change.bind(this));
      this.$toggleElement.on('change', this.change.bind(this));

      log('ready', this.$element);

      this.change();
  }

  change () {
    var isChecked = this.$toggleElement.is(':checkbox') || this.$toggleElement.is(':radio') ? this.$toggleElement.is(':checked') : true;
    var toggleValues = typeof(this.togglevalue) !== 'undefined' ? this.togglevalue.split(',') : '';

    this.value = this.$toggleElement.val();
    if (this.$toggleElement.length > 1 && isChecked) {
        var selector =  this.$element.attr(ATTR_ELEMENT_SELECTOR);
        this.value = $(selector + ':checked').val();
    }

    log('change', this.$element, this.value, this.initial);
    if (typeof(this.toggleNotValue) !== 'undefined') {
      var values = this.toggleNotValue.split(',');
      if (values.indexOf(this.value) >= 0 && isChecked) {
        this.$element.hide();
        this.onHide();
      }
      else {
        this.showElement();
        this.onShow();
      }
    }
    else if (toggleValues.indexOf(this.value) >= 0 && isChecked) {
      this.showElement();
      this.onShow();
    }
    else {
      this.$element.hide();
      this.onHide();
    }
  }

  clearElement() {
    this.$element.find(':checked').removeAttr('checked').trigger('change');
    this.$element.find('[type="text"]').val('');
    this.$element.find('textarea').val('');
    this.$element.find('select').val('');
  }

  disableElements() {
    Array.from(this.element.querySelectorAll("input, textarea, select"))
        .forEach((element)=>{
            element.disabled = true;
        });
  }

  enableElements() {
    Array.from(this.element.querySelectorAll("input, textarea, select"))
        .forEach((element)=>{
            element.disabled = false;
        });
  }

  showElement() {
    this.$element.show();
    if (this.removeClassname.length > 0 && this.$element.hasClass(this.removeClassname)) {
      this.$element.removeClass(this.removeClassname);
    }
  }
}

plugin(PLUGIN_NAME, ToggleIfValue);

export function exec () {
  $(document).ready(() => {
    $(ELEMENT_SELECTOR)[PLUGIN_NAME]();
  });
}



// WEBPACK FOOTER //
// ./project/client/src/core/modules/toggle-if-value/index.js